export const LAMBDATEST_TEST_STREAM_LOADING = "LAMBDATEST_TEST_STREAM_LOADING";
export const LAMBDATEST_TEST_STREAM_SUCCESS = "LAMBDATEST_TEST_STREAM_SUCCESS";
export const LAMBDATEST_TEST_STREAM_FAILED = "LAMBDATEST_TEST_STREAM_FAILED";
export const LAMBDATEST_TEST_STREAM_CLEAR = "LAMBDATEST_TEST_STREAM_CLEAR";
export const LAMBDATEST_TEST_STREAM_CURRENT_FETCH =
  "LAMBDATEST_TEST_STREAM_CURRENT_FETCH";
export const SWITCH_LIVE_INTERACTION = "SWITCH_LIVE_INTERACTION";
export const SET_REALTIME_KEY = "SET_REALTIME_KEY";
export const CHANGE_LIVE_STREAM_TYPE = "CHANGE_LIVE_STREAM_TYPE";
export const LAMBDATEST_TEST_RESET_STREAM_DRAWER =
  "LAMBDATEST_TEST_RESET_STREAM_DRAWER";
export const SET_CROPPED_VIDEO = "SET_CROPPED_VIDEO";
export const RESET_CROPPED_VIDEO = "RESET_CROPPED_VIDEO";
